import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Langs from "../../../app/lang/langs";
import ConfirmDialog from '../../popups/ConfirmDialog';
import { showErrorToast } from '../../../app/utils/helpers';
import moment from 'moment';
import { deletePlanning, getPlanning } from '../../../containers/planning/planningSlice';

export function DeleteFormModal(props) {

    const dispatch = useDispatch()

    const collabs = useSelector((state) => state.collabs.list)
    const selectedView = useSelector((state) => state.planning.selectedView)
    const selectedDate = useSelector((state) => state.planning.selectedDate)
    const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds)

    function hide() {
        props.onHide()
    }

    function handleDeletePlanning() {
        let range = "month"
        if (selectedView == "WEEKLY") {
            range = "week"
        }
        let from = moment(selectedDate).startOf(range).format("x")
        let to = moment(selectedDate).endOf(range).format("x")

        if(from && to){
            let params = {
                teamIds: selectedTeamsIds,
                from: from,
                to: to
            }
            dispatch(deletePlanning(params)).then((response) => {
                if (response['payload']['responseData']['status'] == 1) {
                    loadPlanning()
                }
                if (response['payload']['responseData']['status'] == 4) {
                    showErrorToast(response['payload']['responseData']['message'])
                }
                if (response['payload']['responseError']) {
                    showErrorToast()
                }
            })
        }
        hide()
        
    }

    function loadPlanning(){
        if (selectedTeamsIds && selectedTeamsIds.length && collabs.length) {
          let selectedCollabsIds = collabs.reduce((array, current) =>{
            array.push(current.id)
            return array
          }, [])
          dispatch(getPlanning({selectedTeamsIds, selectedCollabsIds}))
        }
    }

    return <ConfirmDialog
        open={!!props.show}
        danger
        title={<Langs str='Delete planning' />}
        message={<Langs str='DELETE_PLANNING_VALIDATION_MSG' />}
        onConfirm={() => handleDeletePlanning()}
        onCancel={() => hide()}
    />
}
